import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { tablet } from '../../theme';
export default {
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    minHeight: '100vh',
    '& > *': {
      flex: '0 0 auto',
      width: '100%'
    }
  },
  main: _objectSpread({
    paddingBottom: '3rem',
    paddingTop: function paddingTop(props) {
      var _props$theme;
      return (props == null ? void 0 : (_props$theme = props.theme) == null ? void 0 : _props$theme.contentPosition) === 'middle' ? '3rem' : '0';
    },
    marginTop: function marginTop(props) {
      var _props$theme2;
      return (props == null ? void 0 : (_props$theme2 = props.theme) == null ? void 0 : _props$theme2.contentPosition) === 'middle' ? 'auto' : '0';
    },
    marginBottom: 'auto',
    '& > *': {
      paddingLeft: '1rem',
      paddingRight: '1rem'
    },
    // vertical spacing
    '& > * + *': {
      marginTop: '2.5rem'
    },
    '& > *:first-child': {
      marginTop: '3rem'
    },
    '& > $nav + $title': {
      marginTop: '5rem'
    },
    '& > $title:first-child': {
      marginTop: '3rem'
    },
    '& > $nav:first-child': {
      marginTop: '1rem'
    }
  }, tablet({
    paddingBottom: '6rem',
    paddingTop: function paddingTop(props) {
      var _props$theme3;
      return (props == null ? void 0 : (_props$theme3 = props.theme) == null ? void 0 : _props$theme3.contentPosition) === 'middle' ? '6rem' : '3rem';
    }
  })),
  nav: {},
  title: {}
};